import React, {useEffect, useRef, useState} from "react";
import FaIcon from "./FaIcon";

// Replaces the jQuery fadeIn/fadeOut + animate() from the removed public/assets/js/scripts.js.
// #scrollUp is display:none in style.css; it fades in after 300px of scrolling.
const OFFSET = 300;
const FADE_MS = 500;

export default function ScrollToTopButton() {
    const [visible, setVisible] = useState(false);   // should be shown
    const [rendered, setRendered] = useState(false); // display:block (stays on during fade-out)
    const hideTimer = useRef(null);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > OFFSET);
        onScroll();
        window.addEventListener("scroll", onScroll, {passive: true});
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => {
        clearTimeout(hideTimer.current);
        if (visible) {
            setRendered(true);
        } else {
            hideTimer.current = setTimeout(() => setRendered(false), FADE_MS);
        }
        return () => clearTimeout(hideTimer.current);
    }, [visible]);

    // Start the fade-in one frame after display:block, otherwise the transition is skipped
    const [opaque, setOpaque] = useState(false);
    useEffect(() => {
        if (!visible || !rendered) {
            setOpaque(false);
            return undefined;
        }
        const frame = requestAnimationFrame(() => setOpaque(true));
        return () => cancelAnimationFrame(frame);
    }, [visible, rendered]);

    return (
        <div
            id="scrollUp"
            title="Scroll To Top"
            role="button"
            aria-label="Scroll to top"
            onClick={() => window.scrollTo({top: 0, behavior: "smooth"})}
            style={{
                display: rendered ? "block" : "none",
                opacity: opaque ? 1 : 0,
                // keep the hover transition from style.css (#scrollUp: all 0.4s)
                transition: `opacity ${FADE_MS}ms, background-color 0.4s ease-in-out`,
            }}
        >
            <FaIcon className="fas fa-arrow-up"/>
        </div>
    );
}
